import { CommonService } from './../../services/common.service';
import { FormControl, FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

// Custom Validator used to match password entered
function passwordMatcher(c: AbstractControl) {
  const newPasswordControl = c.get('newPassword');
  const confirmNewPasswordControl = c.get('confirmPassword');
  if ((newPasswordControl && newPasswordControl.pristine) || (confirmNewPasswordControl && confirmNewPasswordControl.pristine)) {
    return null;
  }
  if (newPasswordControl && confirmNewPasswordControl && newPasswordControl.value === confirmNewPasswordControl.value) {
    return null;
  }
  return {'match' : true};
}
@Component({
  selector: 'password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.css']
})
export class PasswordComponent implements OnInit {
  @Input('showOldPassword') showOldPassword: boolean = false;
  @Input('showConfirmPassword') showConfirmPassword: boolean = false;
  @Output('isValidPassword') isValidPassword = new EventEmitter<boolean>();
  @Output('isPasswordMatch') isPasswordMatch = new EventEmitter<boolean>();
  @Output('oldPassword') oldPassword = new EventEmitter<string>();
  @Output('newPassword') newPassword = new EventEmitter<string>();

  hide = true;
  hideConfirm = true;
  user_validation_messages: any = {
    'oldPassword': [
      { class: 'passwordValidate', message: 'Please enter old password' }
    ],
    'newPassword': [
      { class: 'passwordValidate', message: 'Please enter password' }
    ],
    'confirmPassword': [
      { class: 'confirmPasswordValidate', message: 'Please enter confirm password' }
    ]
  };
  passwordStatus: any;

  passwordFormGroup: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    // public passwordFormGroup: FormGroup
  ) {
    this.passwordFormGroup = this.formBuilder.group({
      oldPassword: this.showOldPassword ? ['', Validators.required] : [''],
      newPasswordGroup: new FormGroup({
        newPassword: new FormControl('', Validators.required),
        confirmPassword: this.showConfirmPassword ? new FormControl('', Validators.required) : new FormControl('')
      },{validators: passwordMatcher})
    });
  }

  ngOnInit() {

  }

  isPasswordValid(field: string): boolean {
    return !this.passwordFormGroup.get(field)?.valid && this.passwordFormGroup.get(field)?.touched ? true : false;
  }



  checkPasswordStatus() {
    this.passwordStatus = this.commonService.checkPasswordValidation(this.passwordFormGroup.controls.newPasswordGroup.value.newPassword);
    this.validatePasswordGroup();
  }

  confirmNewPassword() {
    const isPasswordMatch = this.passwordFormGroup.controls.newPasswordGroup.value.newPassword === this.passwordFormGroup.controls.newPasswordGroup.value.confirmPassword;
    this.isPasswordMatch.emit(isPasswordMatch);
  }

  validatePasswordGroup() {
    if (this.passwordStatus.passwordIsValidated) {
      this.isValidPassword.emit(true);
      this.newPassword.emit(this.passwordFormGroup.controls.newPasswordGroup.value.newPassword);
      return;
    }

    this.isValidPassword.emit(false);
  }

}
